import { render, staticRenderFns } from "./Fournisseurs.vue?vue&type=template&id=28180040&scoped=true"
import script from "./Fournisseurs.vue?vue&type=script&lang=js"
export * from "./Fournisseurs.vue?vue&type=script&lang=js"
import style0 from "./Fournisseurs.vue?vue&type=style&index=0&id=28180040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28180040",
  null
  
)

export default component.exports